import React from 'react';
import { FormRow, FormColumn } from '@xo-union/tk-component-form-grid';
import Icon from '@xo-union/tk-component-icons';
import SectionHeader from '../SectionHeader';
import TextArea from './textarea';
import styles from './styles.scss';

const Notes: React.FC<{}> = () => (
  <>
    <SectionHeader>My Notes</SectionHeader>
    <FormRow>
      <FormColumn xs md>
        <TextArea name="coupleNote" placeholder="Enter notes about your guests, like food allergies" disabled={false} />
      </FormColumn>
    </FormRow>
  </>
);

export const RsvpNotes: React.FC<{}> = () => (
  <>
    <SectionHeader>Guest Notes</SectionHeader>
    <FormRow>
      <FormColumn xs md>
        <TextArea name="rsvpNote" placeholder="" disabled />
        <div className={styles.padlock}>
          <Icon className={styles.padlockIcon} name="padlock" size="sm" />
          <span className={styles.lockedMessage}>Locked</span>
        </div>
      </FormColumn>
    </FormRow>
  </>
);

export default Notes;
